import styled from "styled-components";
import { getRecapFontFamily } from "./text";

interface HighlightProps {
  fontSize?: string;
  bg?: string;
  borderRadius?: string;
  padding?: string;
  color?: string;
  fontWeight?: string;
  fontFamily?: 'basis' | 'plain' | 'maison-neue' | 'fifties-cond-med' | 'pp';
  letterSpacing?: string;
  lineHeight?: string;
  justifyContent?: string;
}

export const Highlight = styled.div<HighlightProps>`
  display: inline-flex;
  align-items: center;
  justify-content: ${props => props.justifyContent || 'center'};
  min-height: 54px;
  background-color: ${props => props.bg || '#ffffff'};
  color: ${props => props.color || '#e31a37'};
  border-radius: ${props => props.borderRadius || '0.4rem'};
  padding: ${props => props.padding || '0 0.75rem'};
  font-size: ${props => props.fontSize || '20px'};
  ${props => getRecapFontFamily(props.fontFamily || 'fifties-cond-med')};
  text-transform: uppercase;
  line-height: ${props => props.lineHeight || '1'};
  font-weight: ${props => props.fontWeight || '400'};
  letter-spacing: ${props => props.letterSpacing || 'normal'};
  z-index: 3;
`;

export default Highlight;